import React from "react";
import moment from "moment";
import { Modal } from "reactstrap";
import "./ExamPlanLiveQnaAlert.scss";

const formatDate = (value) => {
    const date = moment(value, ["YYYY-MM-DD", "YYYYMMDD"], true);
    return date.isValid() ? date.format("YYYY.MM.DD") : "";
};

const formatTime = (value) => (value ? String(value).slice(0, 5) : "");

function ExamPlanLiveQnaAlert({ isOpen, schedule, isClosedExam = false, onClose }) {
    const startDate = formatDate(schedule?.RLTM_INQ_START_DT);
    const endDate = formatDate(schedule?.RLTM_INQ_END_DT);
    const startTime = formatTime(schedule?.RLTM_INQ_START_TM);
    const endTime = formatTime(schedule?.RLTM_INQ_END_TM);
    const hasSchedule = startDate && endDate && startTime && endTime;

    return (
        <Modal isOpen={isOpen} toggle={onClose} className="expln-live-qna-alert">
            <header className="expln-live-qna-alert__head">
                <button type="button" className="expln-live-qna-alert__close" aria-label="닫기" onClick={onClose} />
            </header>
            <div className="expln-live-qna-alert__body">
                <h2>{isClosedExam ? "안 내" : "실시간 바로 답변 운영"}</h2>
                {isClosedExam ? (
                    <p className="expln-live-qna-alert__unavailable">
                        바로답변 서비스는 3학년 2학기 기말고사 기간에
                        <br />
                        운영되지 않습니다.
                    </p>
                ) : hasSchedule ? (
                    <div className="expln-live-qna-alert__schedule">
                        <p>
                            {startDate} ~ {endDate} (금요일, 주말 제외)
                        </p>
                        <p>
                            {startTime} ~ {endTime}
                        </p>
                    </div>
                ) : (
                    <p className="expln-live-qna-alert__unavailable">현재 운영 기간이 아닙니다.</p>
                )}
            </div>
            <footer className="expln-live-qna-alert__foot">
                <button type="button" onClick={onClose}>
                    확인
                </button>
            </footer>
        </Modal>
    );
}

export default ExamPlanLiveQnaAlert;
